import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppShell from './App';
import { PageDataProvider } from '@/context/PageDataContext';
import { initAnalytics } from '@/utils/analytics';
import './index.css';

const container = document.getElementById('root')!;
const app = (
  <StrictMode>
    <BrowserRouter>
      <PageDataProvider>
        <AppShell />
      </PageDataProvider>
    </BrowserRouter>
  </StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

void initAnalytics();
